import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';

function ProviderWrapper ({ children, store }) {
  return (
    <Provider store={store}>
      <Router>
        { children }
      </Router>
    </Provider>
  );
}

export default ProviderWrapper;
